import { Injectable } from "@angular/core";
import { SelectItem } from "primeng/api";
import { map, Observable } from "rxjs";
import { MICustomFunctionsParams } from "../../models/fields/custom-function-params";
import { ListsForFieldsFunctions } from "./common/lists-for-fields";

@Injectable({
    providedIn: 'root'
})
export class TransportService {

    constructor() {

    }

    getModelYear(customFunctionsObj: MICustomFunctionsParams): Observable<Array<SelectItem>> {
        const listsForFieldsFunctions = customFunctionsObj.injector.get(ListsForFieldsFunctions);
        const lowestYearsNumber = 100;

        return listsForFieldsFunctions.getYearsAgoList(customFunctionsObj, lowestYearsNumber).pipe(
            map(yearsList => yearsList.sort((a, b) => Number(b.value) - Number(a.value))));
    }
}